(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-dropdownmenu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('edge-aware-dropdown')) {
        customElements.define('edge-aware-dropdown', class extends HTMLElement {
            connectedCallback() {
                this.controller = new AbortController();
                const options = { signal: this.controller.signal };
                this.panel = this.querySelector('.header-standard-dropdown');
                this.addEventListener('pointerenter', () => this.positionPanel(), options);
                this.addEventListener('focusin', () => this.positionPanel(), options);
                window.addEventListener('resize', () => this.positionPanel(), options);
                window.addEventListener('scroll', () => {
                    if (this.matches(':hover, :focus-within')) this.positionPanel();
                }, { ...options, passive: true, capture: true });
                this.positionPanel();
            }
            positionPanel() {
                if (!this.panel) return;
                this.panel.style.setProperty('--dropdown-shift', '0px');
                const rect = this.panel.getBoundingClientRect();
                const viewportWidth = document.documentElement.clientWidth;
                const shift = rect.left < 16 ? 16 - rect.left : Math.min(0, viewportWidth - 16 - rect.right);
                this.panel.style.setProperty('--dropdown-shift', `${shift}px`);
                this.panel.style.setProperty('--dropdown-available-height', `${Math.max(0, window.innerHeight - rect.top - 16)}px`);
            }
            disconnectedCallback() {
                this.controller.abort();
            }
        });
    }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-swatches"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('variant-tabs')) {
    class VariantTabs extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;

        const tablist = this.querySelector('[role="tablist"]');
        if (!tablist) return;

        this.dataset.initialized = 'true';
        this.tabs = Array.from(tablist.querySelectorAll('[data-variant-tab]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.activate(tab));
          tab.addEventListener('keydown', (event) => this.handleKeydown(event, index));
        });

        this.panels.forEach((panel) => this.setupShowMore(panel));

        const preset = this.tabs.find((tab) => tab.dataset.active === 'true') || this.tabs[0];
        if (preset) this.activate(preset);
      }

      activate(activeTab) {
        const targetId = activeTab.getAttribute('aria-controls');

        this.tabs.forEach((tab) => {
          const selected = tab === activeTab;
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.tabIndex = selected ? 0 : -1;
          tab.classList.toggle('text-neutral-900', selected);
          tab.classList.toggle('border-neutral-900', selected);
          tab.classList.toggle('text-neutral-500', !selected);
          tab.classList.toggle('border-transparent', !selected);
        });

        this.panels.forEach((panel) => {
          panel.hidden = panel.id !== targetId;
        });
      }

      handleKeydown(event, index) {
        if (!['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;

        event.preventDefault();
        let targetIndex = index;

        if (event.key === 'ArrowRight') targetIndex = (index + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') targetIndex = (index - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') targetIndex = 0;
        if (event.key === 'End') targetIndex = this.tabs.length - 1;

        const targetTab = this.tabs[targetIndex];
        targetTab.focus();
        this.activate(targetTab);
      }

      setupShowMore(panel) {
        const button = panel.querySelector('[data-show-more]');
        const list = panel.querySelector('[data-swatch-list]');
        if (!button || !list) return;

        const limit = Number.parseInt(button.dataset.limit || '10', 10);
        const items = Array.from(list.querySelectorAll('[data-swatch]'));
        const desktop = window.matchMedia('(min-width: 768px)');
        const showMoreText = this.dataset.showMoreText;
        const showLessText = this.dataset.showLessText;

        const collapse = () => {
          items.forEach((item, index) => {
            if (index >= limit) item.classList.add('hidden');
          });
          button.setAttribute('aria-expanded', 'false');
          button.textContent = showMoreText;
        };

        const expand = () => {
          items.forEach((item, index) => {
            if (index >= limit) item.classList.remove('hidden');
          });
          button.setAttribute('aria-expanded', 'true');
          button.textContent = showLessText;
        };

        const applyViewport = () => {
          if (desktop.matches) {
            items.forEach((item) => item.classList.remove('hidden'));
            button.classList.add('hidden');
            return;
          }

          button.classList.remove('hidden');
          if (button.getAttribute('aria-expanded') === 'true') {
            expand();
          } else {
            collapse();
          }
        };

        button.addEventListener('click', () => {
          if (button.getAttribute('aria-expanded') === 'true') {
            collapse();
          } else {
            expand();
          }
        });

        applyViewport();
        desktop.addEventListener('change', applyViewport);
      }
    }

    customElements.define('variant-tabs', VariantTabs);
  }
  } catch(e) { console.error(e); }
})();

})();
